import React, {Component} from 'react'
import {connect} from 'react-redux'
import {FJModalAction} from "../../../redux/action/FJRoot.action";
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJUnsupportSafariModal from '../view/FJUnsupportSafariModal';

class FJUnsupportSafariModalContainer extends Component {
    render() {
        let {
            visible,
            onCancel
        } = this.props;
        return (
            <FJCommonModal visible={visible}
                           hasOuterCloseBtn
                           hasInnerTitle={false}
                           onCancel={onCancel}
                           width={500}
            >
                <FJUnsupportSafariModal visible={visible}
                               onCancel={onCancel}
                />
            </FJCommonModal>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        visible: state.modal.isShowUnsupportSafariModal,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        onCancel: function () {
            dispatch(FJModalAction.setIsShowUnsupportSafariModalAction(false));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJUnsupportSafariModalContainer);